export default "__VITE_ASSET__CQf0HlHm__"